/** Fire-and-forget chunk preload for marketing nav links. */
const LOADERS = {
  "/contact-us": () => import("./pages/contact_us"),
  "/about-us": () => import("./pages/about_us"),
  "/demo": () => import("./pages/demo"),
  "/products": () => import("./pages/products"),
  "/pricing": () => import("./pages/pricing"),
  "/privacy-policy": () => import("./pages/privacy_policy"),
  "/terms-and-services": () => import("./pages/terms_and_services"),
  "/case-studies": () => import("./pages/case_studies"),
  "/for/orthopedics": () => import("./pages/for_orthopedics"),
  "/for/physiotherapy": () => import("./pages/for_physiotherapy"),
  "/for/cardiology": () => import("./pages/for_cardiology"),
  "/for/pulmonology": () => import("./pages/for_pulmonology"),
  "/for/oncology": () => import("./pages/for_oncology"),
  "/compare/healthplix": () => import("./pages/compare_healthplix"),
  "/security-abdm": () => import("./pages/security_abdm"),
  "/generate-ai-patient-summary": () => import("./pages/generate_ai_patient_summary"),
  "/nutritional-agent": () => import("./pages/nutritional_agent"),
  "/voice-receptionist-agent": () => import("./pages/voice_receptionist_agent"),
};

export function prefetchRoute(path) {
  LOADERS[path]?.();
}
